import * as React from 'react'
import { ComponentType, useEffect } from 'react'
import { SagaMiddleware } from '@redux-saga/core'
import mainSaga from '../../core/store/sagas'

interface Props {
    sagaMiddleware: SagaMiddleware
}

const withSaga = (ComposedComponent: ComponentType<Props>) => {
    const WithSaga: React.FC<Props> = ({ sagaMiddleware, ...props }) => {
        useEffect(() => {
            sagaMiddleware.run(mainSaga)
        }, [sagaMiddleware])
        return <ComposedComponent sagaMiddleware={sagaMiddleware} {...props} />
    }
    return WithSaga
}

export default withSaga
